import React from 'react';
import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Paper,
  OutlinedInput,
} from '@mui/material';
import { ServiceLogFilters } from '../serviceLog';
import { commonDateFieldProps } from '../../../../utils/styles';

interface ServiceLogFiltersProps {
  filters: ServiceLogFilters;
  onFilterChange: (filters: ServiceLogFilters) => void;
}

const ServiceLogFiltersComponent: React.FC<ServiceLogFiltersProps> = ({
  filters,
  onFilterChange,
}) => {
  const handleChange = (field: keyof ServiceLogFilters) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    onFilterChange({
      ...filters,
      [field]: value,
    });
  };

  const handleClearFilters = () => {
    onFilterChange({
      vehicleId: filters.vehicleId,
      serviceDate: new Date().toISOString().split('T')[0],
      serviceType: '',
    });
  };

  return (
    <Paper sx={{ p: 1.5 }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            {...commonDateFieldProps}
            fullWidth
            type="date"
            label="Start Date"
            value={filters.serviceDate}
            onChange={handleChange('serviceDate')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel sx={{ fontSize: '12px' }}>Service Type</InputLabel>
            <Select
              value={filters.serviceType}
              label="Service Type"
              onChange={handleChange('serviceType') as any}
              input={<OutlinedInput label="Service Type" />}
              sx={{ fontSize: '12px' }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              <MenuItem value="" sx={{ fontSize: '12px' }}>All</MenuItem>
              <MenuItem value="FREE" sx={{ fontSize: '12px' }}>FREE</MenuItem>
              <MenuItem value="PAID" sx={{ fontSize: '12px' }}>PAID</MenuItem>
              <MenuItem value="OTHER" sx={{ fontSize: '12px' }}>OTHER</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {((filters.serviceDate && filters.serviceDate !== new Date().toISOString().split('T')[0]) || (filters.serviceType && filters.serviceType !== '')) && <Grid item xs={12} md="auto" sx={{ marginLeft: 'auto' }}>
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            size="small"
            sx={{ px: 1, py: 0.5, fontSize: '12px' }}
          >
            Clear Filters
          </Button>
        </Grid>}
      </Grid>
    </Paper>
  );
};

export default ServiceLogFiltersComponent; 